/**
 * @deprecated Import from 'src/integrations/nextjs/utils.js' instead.
 */
export {
  getNextJsVersionBucket,
  NextJsRouter,
  getNextJsRouter,
  getNextJsRouterName,
} from '../integrations/nextjs/utils.js';
